import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';

export const liveValidationInputFormFieldExtension: ExtensionDefinition =
  FormFieldBlueprint.make({
    name: 'live-validation-input-form-field-extension',
    params: {
      field: () =>
        import('./live-validation-input').then(
          m => m.LiveValidationInputFormField,
        ),
    },
  });
